import { axios } from '../../services/axios';
import { SBCAAS_MODERN_LABEL } from '@/constants/sbcaas';

export default async function createSRTService(companyID, regions, trunkTypes) {
    return axios
        .post('/Service/SRT', {
            name: SBCAAS_MODERN_LABEL,
            companyID,
            maxChannel: 0,
            regions,
            trunkTypes,
        })
        .then((res) => res)
        .catch((e) => e);
}
